import { log } from "../utils/log_utils"
const WORKER_API_URL = process.env.REACT_APP_WORKER_API_URL || "http://localhost:8787"

let isRefreshing = false;
let refreshPromise = null;

const refreshTokens = async () => {
  const res = await fetch(WORKER_API_URL + '/auth/refresh', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    credentials: 'include',
  });
  const data = await res.json();
  if (!data.success) {
    throw new Error("Token refresh failed");
  }
  return data;
};

const clearSessionAndRedirect = async () => {
  log("Session expired, logging out");
  localStorage.clear();
  try {
    await fetch(WORKER_API_URL + '/auth/logout', {
      method: 'POST',
      credentials: 'include',
    });
  } catch (err) {
    log("Logout request failed", err);
  }
  window.dispatchEvent(new Event('force-logout'));
};

const apiClient = async (url, options = {}, _isRetry = false) => {
    const res = await fetch(WORKER_API_URL + url, {
      headers: {
        "Content-Type": "application/json",
        ...options.headers
      },
      credentials: 'include',
      ...options
    });
    const { success, resp } = await res.json()

    if (!success && resp === "UNAUTHORIZED_REQUEST") {
      log("api call failed", resp, url);

      // If this is already a retry, give up
      if (_isRetry) {
        clearSessionAndRedirect();
        return { success: false, resp };
      }

      try {
        // Deduplicate concurrent refresh calls
        if (!isRefreshing) {
          isRefreshing = true;
          refreshPromise = refreshTokens();
        }
        await refreshPromise;
      } catch (err) {
        log("Token refresh failed", err);
        clearSessionAndRedirect();
        return { success: false, resp };
      } finally {
        isRefreshing = false;
        refreshPromise = null;
      }

      // Retry the original request once
      return apiClient(url, options, true);
    }

    return { success, resp };
  };
  
export default apiClient;